// D:\Event\frontend\src\components\Coupon.js
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Coupon() {
  const location = useLocation();

  // read email from state passed via <Link state={{ email }}>
  const email = location?.state?.email || "";

  useEffect(() => {
    if (email) {
      console.log("Received email in Coupon page:", email);
    } else {
      console.log("No email received in Coupon page");
    }
  }, [email]);

  return (
    <div className="react-background"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontFamily:
          "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
      }}
    >
      <div
        style={{
          borderRadius: 16,
          padding: "24px 28px",
          minWidth: 300,
          textAlign: "center",
        }}
      >
      <p>Welcome to the Coupon Page!</p>
<p>Your gift coupon will be sent to you shortly.</p>


       
      </div>
    </div>
  );
}
